import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useNextUrl } from 'app/lib/hooks/useNextUrl'
import { Routes } from 'app/routes/Routes'
import { Link } from 'react-router-dom'

const LoginLink = () => {
  const { nextUrl } = useNextUrl()
  const { tButtonTitle } = ToolBox.useString()

  return (
    <Link to={`${Routes.Authentication.collection().login}?next_url=${nextUrl}`}>
      {tButtonTitle({ recordType: RecordType.session, action: 'back_to_login' })}
    </Link>
  )
}

export default LoginLink
